import styled from 'styled-components';

export const UndoRedo = styled.div`
    display: inline-block;
    position: relative;
    height: 100%;
    width: 90px;
`;

export const UndoIconDiv = styled.div`
    margin-top: 6px;
    margin-left: 10px;
`;

export const RedoIconDiv = styled.div`
    position: absolute;
    right: calc(50% - 34px);
    top: calc(50% - 19px);
    height: 30px;
`;

export const VerticalDivider = styled.div`
    position: absolute;
    left: calc(50%);
    width: 1px;
    height: 30px;
    top: calc(50% - 16px);
    background-color: lightgray;
`;
